import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import privacyConfig from '../config/privacy';

const PrivacyPage = () => {
  const { t, i18n } = useTranslation();
  const isFr = i18n.language.startsWith('fr');
  const responsibleTitle = isFr ? privacyConfig.responsibleTitleFr : privacyConfig.responsibleTitleEn;
  const responsibleAddress = isFr ? privacyConfig.responsibleAddressFr : privacyConfig.responsibleAddressEn;

  return (
    <div className="legal-page-shell">
      <div className="legal-page-card">
        <div className="legal-page-header">
          <div>
            <h1>{t('legal.title')}</h1>
            <p>{t('legal.subtitle', { organization: privacyConfig.organizationName })}</p>
          </div>
          <Link to="/login" className="btn btn-outline">
            {t('legal.backToLogin')}
          </Link>
        </div>

        <section className="legal-section">
          <h2>{t('legal.responsibleHeading')}</h2>
          <div className="legal-contact-card">
            <p><strong>{responsibleTitle}</strong></p>
            <p>{privacyConfig.responsibleName}</p>
            <p>
              <a href={`mailto:${privacyConfig.responsibleEmail}`}>{privacyConfig.responsibleEmail}</a>
            </p>
            {privacyConfig.responsiblePhone && <p>{privacyConfig.responsiblePhone}</p>}
            {responsibleAddress && <p>{responsibleAddress}</p>}
          </div>
        </section>

        <section className="legal-section">
          <h2>{t('legal.policyHeading')}</h2>
          <p>{t('legal.policyIntro', { organization: privacyConfig.organizationName })}</p>
          <ul className="legal-list">
            <li>{t('legal.policyItems.collection')}</li>
            <li>{t('legal.policyItems.use')}</li>
            <li>{t('legal.policyItems.access')}</li>
            <li>{t('legal.policyItems.security')}</li>
            <li>{t('legal.policyItems.retention')}</li>
            <li>{t('legal.policyItems.rights')}</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>{t('legal.contactHeading')}</h2>
          <p>{t('legal.contactText')}</p>
          <p>
            <a href={`mailto:${privacyConfig.responsibleEmail}`}>{privacyConfig.responsibleEmail}</a>
          </p>
        </section>

        <p className="legal-meta">
          {t('legal.lastUpdated', { date: privacyConfig.lastUpdated })}
        </p>
      </div>
    </div>
  );
};

export default PrivacyPage;
